module.exports = __webpack_public_path__ + "img/biaogexiazai.025ecb47.png";